import { getPaginated } from '@/api/implementation/app/wrapper.js';

export const autocomplete = (...args) => getPaginated(`client/autocomplete`, ...args);
